document.addEventListener('DOMContentLoaded', () => {
    /*
    *  Blog // Table of componentes
    *  
    *  1. Blog listing page (Blog home)
    *  2. Blog post single page (Article page)
    */

    /**
    *  1. Blog listing page // Table of componentes
    *
    *  1.1. Blog hero slider
    *  1.2. Blog category anchor links
    *  1.3. Blog sliders by category
    */

    /** 1.1. Blog hero slider */

    const __headerSliderSection = document.querySelector('.blog-header-slider');

    if(__headerSliderSection) {
        const __headerSlider = __headerSliderSection.querySelector('.blog-header-slider__slider');

        if(__headerSlider) {
            const __headerBlogPostSwiper = new Swiper(__headerSlider, {
                loop: false,
                autoHeight: true,
                draggable: true,
                slidesPerView: 1,
                centeredSlides: false,
                a11y: true,
                spaceBetween: 0,
                freeMode: false,
                keyboard: {
                    enabled: true,
                    onlyInViewport: true
                },
                grabCursor: false,
                pagination: {
                    el: '.swiper-pagination',
                    clickable: true,
                },
                navigation: {
                    nextEl: '.blog-header-slider__next-btn',
                    prevEl: '.blog-header-slider__prev-btn',
                },
            });
        }
    }

    /** 1.2. Blog sliders by category */

    const __categoryLinksNav = document.querySelector('.blog-category-anchor-links__links-list');

    if(__categoryLinksNav) {
        const __categoryLink = __categoryLinksNav.querySelectorAll('.blog-category-anchor-links__link-item > a[href^="#"]');

        __categoryLink?.forEach(function (link) {
            link?.addEventListener("click", function(e) {
                let __hashval = e.target?.getAttribute('href');
                let __categorySection = document.querySelector(`.blog-slider-category > div${__hashval}`);
                if(__categorySection) {
                    let __top = Number(__categorySection.offsetTop) - 50;
                    window.scroll({
                        top: __top,
                        behavior: 'smooth'
                    });
                }
                history.replaceState('', document.title, window.location.origin + window.location.pathname + window.location.search);
                e.preventDefault();
            });
        });
    }

    /** 1.3. Blog sliders by category */

    const __blogSliderCategoryWrapper = document.querySelectorAll('.blog-slider-category__slider-wrapper');

    __blogSliderCategoryWrapper?.forEach(function (section) {
        const __categorySlider = section.querySelectorAll('.blog-slider-category__slider');
        const __prevButton = section.querySelectorAll('.swiper-button-prev');
        const __nextButton = section.querySelectorAll('.swiper-button-next');
        __categorySlider?.forEach((categorySlider, index) => {
            const __sliderForBlogCategory = new Swiper(categorySlider, {
                loop: false,
                autoHeight: true,
                draggable: true,
                slidesPerView: 3.5,
                centeredSlides: false,
                a11y: true,
                spaceBetween: 30,
                freeMode: false,
                breakpoints: {
                    300: {
                        slidesPerView: 1.3,
                    },
                    1024: {
                        slidesPerView: 3.5
                    },
                    1500: {
                        slidesPerView: 4.4
                    },
                    1800: {
                        slidesPerView: 5.4
                    }
                },
                keyboard: {
                    enabled: true,
                    onlyInViewport: true
                },
                grabCursor: false,
                navigation: {
                    prevEl: __prevButton[index],
                    nextEl: __nextButton[index],
                },
            });
        });
    });

    /**
    *  2. Blog post single page // Table of componentes
    *
    *  2.1. Blog post single: Comparision table
    *  2.2. Blog post single: Recent blog posts slider
    */

    /** 2.1. Blog post single: Comparision table */

    if(__comparisionTableMeta) {
        if(__comparisionTableMeta !== undefined && __comparisionTableMeta !== null) {
            const ____comparisionTableWrapper = document.querySelector('.article-content__table-wrapper');
            if(____comparisionTableWrapper) {
                ____comparisionTableWrapper.innerHTML = __comparisionTableMeta;
            }
        }
    }

    /** 2.2. Blog post single: Recent blog posts slider */

    const __recentBlogPostsSliderWrapper = document.querySelector('.recent-blog-posts-slider__slider-wrapper');

    if(__recentBlogPostsSliderWrapper) {
        const __recentBlogPostsSlider = __recentBlogPostsSliderWrapper.querySelector('.recent-blog-posts-slider__slider');

        if(__recentBlogPostsSlider) {
            const __recentBlogPostsSwiper = new Swiper(__recentBlogPostsSlider, {
                loop: false,
                autoHeight: true,
                draggable: true,
                slidesPerView: 3,
                centeredSlides: false,
                a11y: true,
                spaceBetween: 30,
                freeMode: false,
                breakpoints: {
                    300: {
                        slidesPerView: 1
                    },
                    749: {
                        slidesPerView: 2
                    },
                    990: {
                        slidesPerView: 3
                    }
                },
                keyboard: {
                    enabled: true,
                    onlyInViewport: true
                },
                grabCursor: false,
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev',
                },
            });
        }
    }
});